























import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import { ref } from "@vue/composition-api";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
  },
  setup(props) {
    const tableRow = ref(null);

    const investigate = () => {
      EventBus.emit("investigate", props.source);
    };
    return {
      tableRow,
      investigate,
    };
  },
});
